export default "__VITE_ASSET__C13Qb4T0__ 430w";